import { MarkdownEditor, ViewMode } from '@efdigital/ll-addon-codemirror';
import { type QuizQuestion } from '@efdigital/ll-addon-data';
import { SidebarSimple } from '@efdigital/ll-admin-v2/lib/markdown-toolbar';
import Component from '@glimmer/component';

export type EditQuizQuestionMarkdownSignature = {
  Args: {
    question: QuizQuestion;
  };
  Element: HTMLDivElement;
};

export class EditQuizQuestionMarkdown extends Component<EditQuizQuestionMarkdownSignature> {
  setMarkdown = (markdown: string) => {
    this.args.question.markdown = markdown;
  };
  <template>
    <div ...attributes>
      <label class="form-label">Instructions / Details</label>
      <div class="form-text mt-0 mb-3">Add helpful context for the participant:
        instructions, examples, clarifications. Appears below the question
        title. Optional, but recommended.</div>
      <MarkdownEditor
        @markdown={{@question.markdown}}
        @toolbar={{SidebarSimple}}
        @mode={{ViewMode.EditorOnly}}
        @onUpdate={{this.setMarkdown}}
      >
        <:preview as |markdown|>
          <pre>{{markdown}}</pre>
        </:preview>
      </MarkdownEditor>
    </div>
  </template>
}
